import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import {CompanyListWrapper} from './company-list/CompanyList'

const CompanyPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}></Route>

      <Route
        index
        element={
          <>
            <PageTitle>Companies list</PageTitle>
            <CompanyListWrapper />
          </>
        }
      />
    </Routes>
  )
}

export default CompanyPage
